import React from 'react'
import { useNode } from 'react-pagebuilder/hooks/useNode'
import { useEditor } from 'react-pagebuilder/hooks/useEditor'
import { HomeHeroBlockSettings } from './HomeHeroBlockSettings'
import { withBlock } from '../withBlock'
import { withCraft } from '../withCraft'
import { getItemChildren } from 'react-pagebuilder/utils/node'
import { homeHeroSlideItemParams } from '../HomeHeroSlide'

export const defaultProps = {}

export const homeHeroBlockItemParams = (enabled, id, blockProps, children) => ({
  pk: id,
  children: getItemChildren(enabled, children?.[0], homeHeroSlideItemParams),
})

export const dynamicProps = []

export const HomeHeroBlock: any = withBlock(
  (props) => {
    const blockProps = {
      ...defaultProps,
      ...props.block,
    }

    const { children } = props

    const _ = props.renderValue

    const {
      id,
      connectors: { connect },
      selected,
      hovered,
      actions: { setProp, setCustom },
      customs,
    } = useNode(
      (state) => ({
        selected: state.events.selected,
        dragged: state.events.dragged,
        hovered: state.events.hovered,
        customs: state.data.custom,
      }),
      props
    )

    const { enabled } = useEditor(
      (state) => ({
        enabled: state.options.enabled,
      }),
      props
    )

    return (
      <div ref={(ref) => props.retRef(ref)} className={`block-home-hero-block ${props.className}`}>
        {children?.[0]}
      </div>
    )
  },
  defaultProps,
  dynamicProps
)

HomeHeroBlock.craft = withCraft({
  name: 'HomeHeroBlock',
  defaultProps: defaultProps,
  settings: HomeHeroBlockSettings,
})
